import React, { forwardRef } from "react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  disabled: boolean;
  label: string;
  width?: string;
  type?: "submit" | "reset" | "button";
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      disabled,
      label,
      width = "8.75rem",
      type = "submit",
      className,
      ...props
    },
    ref
  ) => (
    <button
      ref={ref}
      disabled={disabled}
      type={type}
      {...props}
      className={`${className || ""} ${
        disabled
          ? "bg-button-disabled-color text-placeholder-gray"
          : "bg-button-enabled-color text-card-color"
      } uppercase px-5 py-2 rounded-full flex-shrink-0 text-xs font-bold leading-normal tracking-widest flex justify-center items-center`}
      style={{
        maxWidth: "fit-content",
        minWidth: width,
        ...props.style,
      }}
    >
      {label}
    </button>
  )
);

Button.displayName = "Button";

export default Button;
